import { render, staticRenderFns } from "./NoDataFound.vue?vue&type=template&id=52ba0d73&scoped=true&"
import script from "./NoDataFound.vue?vue&type=script&lang=js&"
export * from "./NoDataFound.vue?vue&type=script&lang=js&"
import style0 from "./NoDataFound.vue?vue&type=style&index=0&id=52ba0d73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ba0d73",
  null
  
)

export default component.exports